/**
 * ATR — Average True Range (Wilder smoothing)
 * 波動率指標，量化界常用做停損、部位大小調整
 *
 * true_range = max(high-low, |high-prevClose|, |low-prevClose|)
 */
export function atr(highs, lows, closes, period = 14) {
    if (highs.length < period + 1)
        return undefined;
    if (highs.length !== lows.length || highs.length !== closes.length)
        return undefined;
    const trs = [];
    for (let i = 1; i < highs.length; i++) {
        const h = highs[i];
        const l = lows[i];
        const pc = closes[i - 1];
        trs.push(Math.max(h - l, Math.abs(h - pc), Math.abs(l - pc)));
    }
    // Wilder 平滑：第一個 ATR = 前 period 個 TR 的平均
    let atrVal = trs.slice(0, period).reduce((a, b) => a + b, 0) / period;
    for (let i = period; i < trs.length; i++) {
        atrVal = (atrVal * (period - 1) + trs[i]) / period;
    }
    return atrVal;
}
/**
 * ATR 佔現價的百分比（常用於 vol-adjusted sizing）
 */
export function atrPct(highs, lows, closes, period = 14) {
    const a = atr(highs, lows, closes, period);
    const price = closes[closes.length - 1];
    if (a == null || !price)
        return undefined;
    return a / price;
}
//# sourceMappingURL=atr.js.map